import type { ComponentType } from 'react'
import { isBatch1SurveyQuestionType } from '../../../lib/survey-question.types'
import type { SurveyDraftAnswer, SurveyQuestion } from '../../../lib/survey-question.types'
import { UnsupportedQuestionType } from './UnsupportedQuestionType'
import {
  isSurveyChoiceQuestionType,
  surveyQuestionRendererByType,
  type SurveyChoiceQuestionRendererProps,
  type SurveyQuestionRendererProps as MapQuestionRendererProps,
} from './surveyQuestionRendererMap'

interface SurveyQuestionRendererProps {
  readonly question: SurveyQuestion
  readonly value: SurveyDraftAnswer
  readonly displaySeed: string
  readonly onChange: (value: SurveyDraftAnswer) => void
}

export function SurveyQuestionRenderer({
  question,
  value,
  displaySeed,
  onChange,
}: SurveyQuestionRendererProps) {
  if (question.type === 'unsupported' || !isBatch1SurveyQuestionType(question.type)) {
    return <UnsupportedQuestionType question={question} />
  }

  const Renderer = surveyQuestionRendererByType[question.type]
  if (!Renderer) {
    return <UnsupportedQuestionType question={question} />
  }

  if (isSurveyChoiceQuestionType(question.type)) {
    const ChoiceRenderer = Renderer as ComponentType<SurveyChoiceQuestionRendererProps>
    return (
      <ChoiceRenderer
        question={question}
        value={value}
        displaySeed={displaySeed}
        onChange={onChange}
      />
    )
  }

  const StandardRenderer = Renderer as ComponentType<MapQuestionRendererProps>
  return (
    <StandardRenderer question={question} value={value} onChange={onChange} />
  )
}
